import authentication from '../middleware/authentication'
const Index = () => import(/* webpackChunkName: "static/js/chunks/twilioPhoneNumber" */'../../views/twilioPhoneNumber/index')
const twilioPhoneNumberRoutes = {
  path: '/twilio-phone-numbers',
  name: 'ListTwilioPhoneNumber',
  component: Index,
  meta: {
    middleware: authentication,
    layout: 'main'
  }
}

export default twilioPhoneNumberRoutes
